import { render, staticRenderFns } from "./ReportFormList.vue?vue&type=template&id=1c8006c2&scoped=true&"
import script from "./ReportFormList.vue?vue&type=script&lang=js&"
export * from "./ReportFormList.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormList.vue?vue&type=style&index=0&id=1c8006c2&scoped=true&lang=less&"
import style1 from "./ReportFormList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8006c2",
  null
  
)

export default component.exports